import './index.styl';
import template from './index.jst';
import { Model } from 'backbone';
import { View } from 'backbone.marionette';
import Radio from 'backbone.radio';

const tippingChannel = Radio.channel('tipping');

export class StreakGamebar extends View {
	get template() {
		return template;
	}

	className() {
		return 'tipping-tips-gamebar';
	}

	ui() {
		return {
			save: '.js-save'
		};
	}

	events() {
		return {
			'click @ui.save': 'save',
		};
	}

	initialize() {
		this.model = new Model({
			streak: 0,
			rank: 0,
			active_users: 0,
			total_users: 0,
			total_margin: 0
		});

		this.listenTo(this.model, 'change', this.render);
		this.listenTo(tippingChannel, 'saved', this.onSaved);
		this.listenTo(tippingChannel, 'changed', this.onChanged);
		this.listenTo(tippingChannel, 'streak:update', this.onStreakUpdate);
	}

	save(){
		tippingChannel.trigger('save');
	}

	onSaved(){
		this.ui.save.text('Saved');
	}

	onChanged(){
		this.ui.save.text('Save');
	}

	onStreakUpdate(args){
		this.model.set(args);
	}
}

export default StreakGamebar;